import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import { Card, Col, ListGroup, Row } from "react-bootstrap";
import PsContext from "../../context";
import { ServiceUrl } from "../../utils/serviceUrl";
import {
  groupByMultiple,
  LOADER_LOGO,
  makeUrl,
  momentDate,
  NO_IMAGE_LOGO_WIDE,
  upperCase,
} from "../../utils";
import { Link } from "react-router-dom";

const ViewEvent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataAllList, setAllList] = useState([]);
  const [dataView, setDataView] = useState([]);

  useEffect(() => {
    loadData();
    listData();
  }, [props.match.params]);

  const loadData = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.GET_PAGE + "?type=event&id=" + props.match.params.id)
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  const listData = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.LIST_PAGES + "?type=event&id=" + props.match.params.id)
      .then((res) => {
        if (res["data"].status == "1") {
          setAllList(res["data"].data);
          console.log('ttt', res["data"].data);
        }
        setLoader(false);
      });
  }


  const field = (fieldName) => dataList[fieldName] || "";

  return (
    <div style={{ minHeight: "350px" }}>
      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}

      {!loader && dataList.id && (
        <>
          <SuperSEO title={"Events " + field("title")} lang="en" />

          <section>
            <div className="head-2">
              <div className="container">
                <div className="head-2-inn head-2-inn-padd-top">
                  {/* <h1>{upperCase(field("title"))}</h1> */}
                  <p style={{ fontSize: "15px" }}>
                    <span>{momentDate(field("active_from_date"), "DD")} </span>
                    <span>
                      {momentDate(field("active_from_date"), "MMM,YYYY")}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="container com-sp pad-bot-70 pg-inn ps_min_height px-5">
              <Row>
                <Col md={8}>
                  <div className="ho-event pg-eve-main pg-blog">
                    <h3>{upperCase(field("title"))}</h3>
                    <div>{momentDate(field("active_from_date"))}</div>
                    {/*<ul>
                      <li>
                        <div className="ho-ev-date pg-eve-date">
                          <span>
                            {momentDate(field("active_from_date"), "DD")}
                          </span>
                          <span>
                            {momentDate(field("active_from_date"), "MMM,YYYY")}
                          </span>
                        </div>
                        <div className="pg-eve-desc pg-blog-desc">
                          <a href="event-register.html">
                            <h4>{field("title")}</h4>
                          </a>
                            <div className="share-btn blog-share-btn">
                            <ul>
                              <li>
                                <a href="#">
                                  <i className="fa fa-facebook fb1"></i> Share
                                  On Facebook
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fa fa-twitter tw1"></i> Share On
                                  Twitter
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fa fa-google-plus gp1"></i>{" "}
                                  Share On Google Plus
                                </a>
                              </li>
                            </ul>
      </div>
                        </div>
                      </li>
                    </ul>*/}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: field("content_html"),
                      }}
                    />
                  </div>
                </Col>
                <Col md={4}>
                  {/* <div style={{ border: "1px solid black", height: "120%" }}>
                    <Link to="/events/completed" style={{ fontSize: "15px", border: "1px solid black", marginLeft: "33%" }}>
                      View All Events
                    </Link>
                    {dataList.map((item, i) => {
                        return (

                        );
                      })}

                  </div> */}
                  <div style={{ border: "1px solid black", height: "120%" }}>
                    <Link to="/events/completed" style={{ fontSize: "15px", border: "1px solid black", marginLeft: "33%" }}>
                      View All Events

                    </Link>
                    <br></br>
                    <h5 style={{ textAlign: "center", }}> Recent Events</h5>
                    <ul>
                      {dataAllList.map((item, i) => {

                        return (

                          <li>
                            {/* <h4 style={{ textAlign: "center", fontFamily: "bold" }}>Recent Events</h4> */}
                            <div className="">

                              <a>
                                <h5 style={{ fontSize: "12px" }}> {momentDate(field("active_from_date"), "DD-MM-YYYY")} </h5>
                                {/* <div>{item.title}</div> */}
                                <Link to={`/event/${item.id}/${makeUrl(item.title)}`}>
                                  <div style={{ color: "black" }}>{item.title}</div>

                                </Link>
                              </a>


                            </div>

                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </Col>
              </Row>


            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default ViewEvent;
